import React, { useState, useEffect } from "react";
import { Card, CardHeader, Icon } from "@ui5/webcomponents-react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from "recharts";
import "@ui5/webcomponents-icons/dist/AllIcons.js";
import httpRequest from "../httpRequest";

const FrequentReimbursementClaimantsCard = ({ expenseData }) => {
  const [topEmployees, setTopEmployees] = useState([]);
  const [employees, setEmployees] = useState([]);

  useEffect(() => {
    fetchEmployees();
  }, []);

  useEffect(() => {
    calculateTopEmployees();
  }, [expenseData, employees]);

  const fetchEmployees = async () => {
    try {
      const resp = await httpRequest.get(`${process.env.REACT_APP_BACKEND_URL}/get-employees?exclude_fields=id,position_id,company_id,function_id,address,phone_number,email,location,designation,erp_code,cost_center,companies,functions`);
      setEmployees(resp.data.employees);
    } catch (error) {
      console.error("Error fetching employees:", error);
    }
  };

  const calculateTopEmployees = () => {
    if (!expenseData || expenseData.length === 0) {
      setTopEmployees([]);
      return;
    }

    const suppliersMap = {};

    expenseData.forEach((expense) => {
      const employeeCode = expense.employee_code;
      if (suppliersMap[employeeCode]) {
        suppliersMap[employeeCode].frequency += 1;
      } else {
        const employee = employees.find((v) => v.employee_code === employeeCode);
        suppliersMap[employeeCode] = {
          employee_code: employeeCode,
          employee_name: employee ? employee.employee_name : "Unknown",
          employee_short_name: employee ? employee.employee_name.split(" ").slice(-1)[0] : "Unknown",
          frequency: 1,
        };
      }
    });

    const suppliersArray = Object.keys(suppliersMap).map((key) => suppliersMap[key]);
    suppliersArray.sort((a, b) => b.frequency - a.frequency);
    setTopEmployees(suppliersArray.slice(0, 5)); // Limit to top 5 suppliers
  };

  const sapColors = ["#0a6ed1", "#004b87", "#f0ab00", "#7ca10c", "#d72d42"];

  const getTicks = (maxValue) => {
    const ticks = [];
    for (let i = 0; i <= maxValue; i++) {
      ticks.push(i);
    }
    return ticks;
  };

  const maxFrequency = Math.max(...topEmployees.map(supplier => supplier.frequency), 0);

  return (
    <Card
      header={<CardHeader avatar={<Icon name="supplier" />} subtitleText="By Frequency" titleText="Top Claimants" />}
      style={{ width: '100%', height: '475px',  margin: 'auto' }}
    >
      <div style={{ padding: '0 20px' }}>
        <ResponsiveContainer width="100%" height={370}>
          <BarChart layout="vertical" data={topEmployees}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis 
              type="number" 
              domain={[0, 'dataMax']}
              ticks={getTicks(maxFrequency)}
            />
            <YAxis dataKey="employee_short_name" type="category" />
            <Tooltip formatter={(value, name, props) => [`${value}`, `${props.payload.employee_name}`]} />
            <Bar dataKey="frequency">
              {topEmployees.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={sapColors[index % sapColors.length]} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </Card>
  );
};

export default FrequentReimbursementClaimantsCard;
